module.exports = __webpack_public_path__ + "static/media/card-icon.095a5838.svg";